import React, { useState, useContext } from 'react';
import { string, bool, func } from 'prop-types';
import { Button, Link } from '@one-thd/sui-atomic-components';
import { MOBILE } from '@thd-olt-functional/utils';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Drawer, DrawerItem, DrawerHeader } from '@thd-olt-component-react/drawer';

const CtaSection = ({
  buttonText, hideContactInfo,
  buttonLink, contactNumber, onClick, openContentInDrawer,
  label, labelLink, target, headerDescription
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const isMobile = channel === MOBILE;
  const drawerMaxSize = isMobile ? 100 : 500;

  const handleOpen = (event) => {
    onClick(event);

    if (openContentInDrawer) {
      setIsDrawerOpen(true);
    } else {

      window.open(buttonLink, isConsumerApp ? '_self' : target);
    }
  };

  const onDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <Button
        className="sui-btn sui-btn-primary sui-w-full sui-btn-primary-active sui-font-bold sui-text-base sui-mb-2"
        variant="primary"
        onClick={handleOpen}
      >
        {buttonText}
      </Button>
      {
        !hideContactInfo && contactNumber && (
          <div className="sui-flex sui-justify-center">
            <p className="sui-text-xs sui-text-subtle"> Or call&nbsp;
            </p>
            <Link variant="body-xs" href={`tel:${contactNumber}`}>
              {contactNumber}
            </Link>
          </div>
        )
      }
      {
        (label && labelLink) && (
          <Button
            className="sui-text-sm sui-text-inactive sui-bg-button-secondary sui-w-full"
          >
            <Link target="_blank" rel="noreferrer" href={labelLink}>
              {label}
            </Link>

          </Button>
        )
      }
      {isDrawerOpen && (
        <Drawer
          isMobile={isMobile}
          maxSize={drawerMaxSize}
          open={isDrawerOpen}
          onClose={onDrawerClose}
          initialItem="product-quote"
        >
          <DrawerItem name="product-quote">
            <DrawerHeader title={headerDescription} />
            <iframe title="title" src={buttonLink} width="100%" height="99%" />
          </DrawerItem>
        </Drawer>
      )}
    </>
  );
};

CtaSection.displayName = 'HomeServicesCtaSection';

CtaSection.propTypes = {
  hideContactInfo: bool,
  buttonLink: string.isRequired,
  buttonText: string.isRequired,
  contactNumber: string,
  onClick: func,
  openContentInDrawer: bool,
  label: string,
  labelLink: string,
  target: string,
  headerDescription: string
};

CtaSection.defaultProps = {
  hideContactInfo: false,
  contactNumber: '',
  onClick: () => { },
  openContentInDrawer: true,
  label: '',
  labelLink: '',
  target: '_blank',
  headerDescription: ' '
};

export { CtaSection };